<template>
  <div @click.self="showModalWindow = !showModalWindow" class="modal-window">
    <div class="modal-window__container">
      <h2><slot name="title"/></h2>
      <p><slot name="text"/></p>
      <div class="modal-window__buttons">
        <slot name="buttons"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalWindow',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showModalWindow: this.value,
    };
  },
  watch: {
    showModalWindow() {
      this.$emit('input', this.showModalWindow);
    },
    value() {
      this.showModalWindow = this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-window {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.4);

  &__container {
    width: 260px;
    background-color: #fff;
    padding: 20px;
    border-radius: 6px;

    & h2 {
      font-size: 1.3rem;
    }

    & h2, p {
      margin-bottom: 10px;
    }
  }
}
</style>
